import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { InstagramService, InstagramMedia } from '../../services/instagram.service';

@Component({
  selector: 'app-instagram',
  templateUrl: './instagram.component.html',
  styleUrls: ['./instagram.component.scss']
})
export class InstagramComponent implements OnInit, OnDestroy {
  instagramPosts: InstagramMedia[] = [];
  regularPosts: InstagramMedia[] = [];
  featuredPost: InstagramMedia | null = null;
  loading: boolean = true;
  error: string | null = null;
  expandedCaptions: boolean[] = [];
  featuredPostIsPortrait: boolean = false;
  videoOrientations: boolean[] = [];

  private subscription: Subscription | null = null;

  constructor(private instagramService: InstagramService) { }

  ngOnInit(): void {
    this.fetchInstagramMedia();
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  fetchInstagramMedia(): void {
    this.loading = true;
    this.subscription = this.instagramService.getMedia(12).subscribe({
      next: (media) => {
        this.instagramPosts = media;

        this.featuredPost = this.findFeaturedVideo(media);

        this.regularPosts = this.featuredPost
          ? media.filter(post => post.id !== this.featuredPost!.id)
          : media;

        this.expandedCaptions = new Array(this.regularPosts.length).fill(false);

        this.loading = false;
      },
      error: () => {
        this.error = 'Impossible de charger les photos Instagram';
        this.loading = false;
      }
    });
  }

  findFeaturedVideo(posts: InstagramMedia[]): InstagramMedia | null {
    const videos = posts.filter(post => post.media_type === 'VIDEO');
    return videos.length > 0 ? videos[0] : null;
  }

  openInstaLink(permalink: string): void {
    window.open(permalink, '_blank');
  }

  adjustVideoSize(video: HTMLVideoElement): void {
    const isPortrait = video.videoHeight > video.videoWidth;
    const container = video.closest('.media-container') || video.closest('.featured-media');

    if (container) {
      if (isPortrait) {
        container.classList.add('portrait-video');
        const post = video.closest('.instagram-post');
        if (post) post.classList.add('portrait-post');
      } else {
        container.classList.remove('portrait-video');
        const post = video.closest('.instagram-post');
        if (post) post.classList.remove('portrait-post');
      }
    }
  }

  checkVideoOrientation(event: Event, isFeatured: boolean = false, index: number = -1): void {
    const video = event.target as HTMLVideoElement;
    const isPortrait = video.videoHeight > video.videoWidth;

    if (isFeatured) {
      this.featuredPostIsPortrait = isPortrait;
    } else if (index >= 0) {
      while (this.videoOrientations.length <= index) {
        this.videoOrientations.push(false);
      }
      this.videoOrientations[index] = isPortrait;
    }
  }

  isPortraitVideo(index: number): boolean {
    return this.videoOrientations[index] === true;
  }

  playVideo(event: Event): void {
    const overlay = event.currentTarget as HTMLElement;
    const videoWrapper = overlay.parentElement;
    const video = videoWrapper?.querySelector('video');

    if (video) {
      video.play();
      overlay.style.display = 'none';

      video.addEventListener('ended', () => { overlay.style.display = 'flex'; }, { once: true });
      video.addEventListener('pause', () => { overlay.style.display = 'flex'; }, { once: true });
    }
  }

  expandCaption(index: number): void {
    this.expandedCaptions[index] = true;
  }

  collapseCaption(index: number): void {
    this.expandedCaptions[index] = false;
  }
}
